import Url from 'url';

export function isInternalLink(url: string, hostname: string) {
    if (!url) return;
    const parsedUrl = Url.parse(url);
    return parsedUrl.hostname === null || parsedUrl.hostname === hostname;
}
